<template>
  <div id="page-selects">
    <v-container fluid class="dash-wrap">
      <!-- Header -->
      <div class="d-flex align-center flex-wrap dash-header">
        <div>
          <h1 class="dash-title">{{$t('SystemOverview')}}</h1>
          <div class="dash-subtitle">ภาพรวมผู้ใช้งานและสถานะการแปลผล Lab Result Report</div>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex align-center">
          <span v-if="lastUpdated" class="dash-updated mr-3">
            <v-icon small class="mr-1">mdi-clock-outline</v-icon>{{ lastUpdated }}
          </span>
          <v-btn small outlined color="primary" :loading="loadingStats" @click="updateDashboardStats">
            <v-icon small class="mr-1">mdi-refresh</v-icon>รีเฟรช
          </v-btn>
        </div>
      </div>

      <!-- Summary -->
      <div class="hero-grid">
        <v-card class="stat-card hero-card" flat>
          <div class="stat-icon-wrap" style="background:#eef1ff">
            <v-icon size="36" color="#4f6ef7">mdi-account-multiple</v-icon>
          </div>
          <div class="ml-5">
            <div class="stat-label">ผู้ใช้งานทั้งหมด</div>
            <div class="stat-value">{{ formatNumber(totalUsers) }}</div>
            <div class="stat-caption">บัญชีผู้ใช้งานที่ใช้งานอยู่ในระบบ</div>
          </div>
        </v-card>

        <v-card class="stat-card hero-card" flat>
          <div class="stat-icon-wrap" style="background:#e9f7f0">
            <v-icon size="36" color="#12a06a">mdi-file-document-multiple-outline</v-icon>
          </div>
          <div class="ml-5">
            <div class="stat-label">Lab Result Report ทั้งหมด</div>
            <div class="stat-value">{{ formatNumber(totalOrders) }}</div>
            <div class="stat-caption">รวมทุกสถานะการแปลผล</div>
          </div>
        </v-card>
      </div>

      <!-- Status breakdown -->
      <h2 class="section-title">สถานะ Lab Result Report</h2>

      <div class="status-grid">
        <v-card v-for="s in statusCards" :key="s.key" class="stat-card status-card" flat>
          <span class="status-accent" :style="{ background: s.color }"></span>

          <div class="d-flex align-start justify-space-between">
            <div>
              <div class="stat-value">{{ formatNumber(s.value) }}</div>
              <div class="stat-label mt-1">{{ s.label }}</div>
            </div>
            <div class="stat-icon-wrap sm" :style="{ background: s.tint }">
              <v-icon size="26" :color="s.color">{{ s.icon }}</v-icon>
            </div>
          </div>

          <div class="status-bar">
            <div class="status-bar-fill" :style="{ width: s.percent + '%', background: s.color }"></div>
          </div>

          <div class="d-flex justify-space-between align-center status-foot">
            <span class="status-code">{{ s.key }}</span>
            <span>{{ s.percent }}% ของทั้งหมด</span>
          </div>
        </v-card>
      </div>
    </v-container>
    <v-dialog v-model="logDialog.show" max-width="800px" persistent scrollable>
      <v-card elevation="6" class="pa-0">

        <!-- Header -->
        <v-card-title class="d-flex align-center justify-space-between px-4 py-3" style="background: #f5f6fa; font-weight: 600; font-size: 18px;">
          <div>
            Activity Log File
          </div>
          <!-- <v-btn icon color="grey darken-1" @click="logDialog.show = false">
            <v-icon @click="logDialog.show = false">mdi-close</v-icon>
          </v-btn> -->
          <v-icon @click="logDialog.show = false">mdi-close</v-icon>
        </v-card-title>

        <v-divider></v-divider>

        <!-- Body: Table -->
        <v-card-text class="px-4 py-3" style="max-height: 400px; overflow-y: auto;">
          <v-simple-table dense>
            <thead>
              <tr>
                <th style="width: 260px; text-align: left;">Timestamp</th>
                <th style="text-align: left;">Message</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(log, i) in logDialog.logs" :key="i">
                <td style="font-size: 12px; color: #666;">{{ log.timestamp }}</td>
                <td style="font-size: 14px;">{{ log.message }}</td>
              </tr>
              <tr v-if="logDialog.logs.length === 0">
                <td colspan="2" style="text-align: center; color: #999;">No logs found.</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <!-- Footer -->
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-2 d-flex justify-space-between">
          <div style="font-size: 12px; color: #666;">
            Showing {{ logDialog.logs.length }} log entries
          </div>
          <div style="font-size: 12px; color: #666;">
            Last updated: {{ update }}
          </div>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      loadingStats: false,
      lastUpdated: '',
      totalUsers: 0,
      statusCounts: { OPEN: 0, PROCESSING: 0, WAITING_AI: 0, COMPLETE: 0, Fail: 0 },
      statusMeta: [
        { key: 'OPEN', label: 'พร้อมแปลผล', icon: 'mdi-folder-open-outline', color: '#2f80ed', tint: '#e8f1fd' },
        { key: 'PROCESSING', label: 'กำลังส่งไปแปลผล', icon: 'mdi-progress-clock', color: '#f2994a', tint: '#fdf1e6' },
        { key: 'WAITING_AI', label: 'รอการแปลผล', icon: 'mdi-robot-outline', color: '#9b51e0', tint: '#f4ebfc' },
        { key: 'COMPLETE', label: 'แปลผลแล้ว', icon: 'mdi-check-circle-outline', color: '#12a06a', tint: '#e5f5ef' },
        { key: 'Fail', label: 'ไม่สำเร็จ', icon: 'mdi-close-circle-outline', color: '#eb5757', tint: '#fdecec' }
      ],

      analyzers: [],   // ← จะถูก fill จาก backend
      systems: [],
      statusTimer: null,
      currentInterfaceName: '',
      logDialog: {
        show: false,
        name: '',
        logs: []
      },
      logs: [],
      update: '',
    }
  },

  /* mounted () {
    this.checkStatus()
  }, */
  mounted () {
    this.startStatusTimer() // เริ่ม timer เมื่อ component mount
    this.updateDashboardStats()
  },
  beforeDestroy () {
    // เคลียร์ timer ตอน component ถูกลบ
    if (this.statusTimer) clearInterval(this.statusTimer)
  },

  computed: {
    totalOrders () {
      return this.statusMeta.reduce((sum, m) => sum + (this.statusCounts[m.key] || 0), 0)
    },
    statusCards () {
      return this.statusMeta.map(m => {
        const value = this.statusCounts[m.key] || 0
        return {
          ...m,
          value,
          percent: this.totalOrders ? Math.round((value / this.totalOrders) * 100) : 0
        }
      })
    }
  },

  methods: {

    formatNumber (n) {
      return Number(n || 0).toLocaleString('en-US')
    },
    async updateDashboardStats () {
      this.loadingStats = true
      try {
        const res = await this.axios.post(
          process.env.VUE_APP_API + '/monitor/getDashboardStats',
          { app_name: 'LIS' }
        )
        if (res.data.isSuccess) {
          this.totalUsers = res.data.data.totalUsers
          this.statusCounts = res.data.data.statusCounts
          this.lastUpdated = new Date().toLocaleString('th-TH')
        }
      } catch (err) {
        console.error('Update dashboard stats failed', err)
      } finally {
        this.loadingStats = false
      }
    },
    chipColor (status) {
      if (status === 'Online') return '#2ecc71'
      if (status === 'Warning') return '#f1c40f'
      return '#e74c3c'
    },
    /* async startStatusTimer () {
      // เรียกครั้งแรกทันที
      await this.updateAnalyzerStatus()

      // ตั้ง timer poll ทุก 5 วินาที
      this.statusTimer = setInterval(() => {
        this.updateAnalyzerStatus()
      }, 5000)
    }, */
    async startStatusTimer () {
      // เรียกครั้งแรกทันที
      await this.updateAnalyzerStatus()

      // ตั้ง timer poll ทุก 5 วินาที
      this.statusTimer = setInterval(() => {
        this.updateAnalyzerStatus()
      }, 500000)
    },
    async updateAnalyzerStatus () {
      try {
        // 1เช็ค status ของอุปกรณ์
        const statusResponse = await this.axios.post(
          process.env.VUE_APP_API + '/monitor/checkStatus',
          { app_name: 'LIS' }
        )

        if (statusResponse.data.isSuccess) {
          // 2โหลด device interface หลังจาก status update
          const interfaceResponse = await this.axios.post(
            process.env.VUE_APP_API + '/monitor/retrieveMwDeviceInterface',
            { app_name: 'LIS' }
          )

          if (interfaceResponse.data.isSuccess) {
            const rows = interfaceResponse.data.data
            // แยก Analyzer
            this.analyzers = rows
              .filter(r => r.device_category === 'ANALYZER')
              .map(r => ({
                name: r.device_name,
                type: r.analyzer_category,
                samples: r.samples_processed || 0,
                ip: r.host_addr || '-',
                port: r.port_no || '-',
                socketMode: r.socket_mode,    // <--- เพิ่มบรรทัดนี้เพื่อเก็บค่า SERVER/CLIENT
                protocol: r.conn_type || '-',
                comPort: r.com_port || '-',
                update: this.formatUpdate(r.last_seen),
                status: r.is_online === true ? 'Online' : 'Offline',
                img: this.resolveIcon(r.device_icon),
                interfaceSkey: r.device_skey
              }))
            // แยก System
            this.systems = rows
              .filter(r => r.device_category !== 'ANALYZER')
              .map(r => ({
                name: r.device_name,
                type: r.category,
                samples: r.samples_processed || 0,
                port: r.port_no || '-',
                ip: r.host_addr || '-',
                comPort: r.com_port || '-',
                protocol: r.conn_type || '-',
                update: this.formatUpdate(r.last_update),
                status: r.is_online === true ? 'Online' : 'Offline',
                img: this.resolveIcon(r.device_icon),
                interfaceSkey: r.device_skey
              }))
          }
        }
      } catch (err) {
        console.error('Update analyzer status failed', err)
      }
    },

    /* resolveIcon (fileName) {
      if (!fileName) return require('@/assets/SoftwareClinicIcon/default.png')
      try {
        return require('@/assets/SoftwareClinicIcon/' + fileName)
      } catch (e) {
        return require('@/assets/SoftwareClinicIcon/default.png')
      }
    }, */

    resolveIcon (fileName) {
      const icons = require.context('@/assets/SoftwareClinicIcon', false, /\.png$/)
      return icons.keys().includes('./' + fileName) ? icons('./' + fileName) : icons('./default.png')
    },

    formatUpdate (dt) {
      if (!dt) return 'Last update: -'
      return 'Last update: ' + dt
    },
    async viewLog (interfaceSkey) {
      try {
        console.log('Viewing logs for interfaceSkey:', interfaceSkey)
        console.log('Available analyzers:', this.analyzers)
        const analyzer = this.analyzers.find(a => a.interfaceSkey === interfaceSkey)
        this.logDialog.name = analyzer ? analyzer.name : 'Unknown'

        const res = await this.axios.post(process.env.VUE_APP_API + '/monitor/getInterfaceLogs', {
          device_skey: interfaceSkey
        })

        this.logDialog.logs = res.data.isSuccess ? res.data.data : []
        if (!res.data.isSuccess) {
          this.$swal({ type: 'error', title: res.data.reasonText })
        }

        this.logDialog.show = true
      } catch (err) {
        console.error('Failed to load logs', err)
        this.$swal({ type: 'error', title: err.message })
      }
    },
    goMonitorPage () {
      this.$router.push({ name: 'monitorDetail' })
    },
  }
}
</script>

<style scoped>
/* Page structure */
#page-selects {
  background: #f4f6fa;
  min-height: 100%;
}

.dash-wrap {
  max-width: 1600px;
  margin: 0 auto;
  padding: 28px 28px 40px;
}

.dash-header {
  margin-bottom: 24px;
}

.dash-title {
  font-size: 26px;
  font-weight: 700;
  color: #1f2a3d;
  line-height: 1.2;
}

.dash-subtitle {
  font-size: 14px;
  color: #7b869c;
  margin-top: 4px;
}

.dash-updated {
  font-size: 12px;
  color: #8a94a6;
  white-space: nowrap;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2a3d;
  margin: 32px 0 14px;
}

/* Cards */
.stat-card {
  border-radius: 16px !important;
  border: 1px solid #e7eaf1;
  background: #fff;
  box-shadow: 0 1px 2px rgba(20, 30, 55, 0.04) !important;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.stat-card:hover {
  box-shadow: 0 8px 24px rgba(20, 30, 55, 0.09) !important;
  transform: translateY(-2px);
}

.hero-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  gap: 20px;
}

.hero-card {
  display: flex;
  align-items: center;
  padding: 30px 32px;
}

.status-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.status-card {
  position: relative;
  padding: 24px 24px 20px;
  overflow: hidden;
}

.status-accent {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
}

.stat-icon-wrap {
  width: 68px;
  height: 68px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon-wrap.sm {
  width: 48px;
  height: 48px;
  border-radius: 14px;
}

.stat-label {
  font-size: 14px;
  font-weight: 600;
  color: #55607a;
}

.stat-value {
  font-size: 38px;
  font-weight: 700;
  color: #1f2a3d;
  line-height: 1.1;
}

.hero-card .stat-value {
  font-size: 44px;
  margin: 4px 0;
}

.stat-caption {
  font-size: 12px;
  color: #8a94a6;
}

.status-bar {
  height: 6px;
  border-radius: 999px;
  background: #eef1f6;
  margin-top: 18px;
  overflow: hidden;
}

.status-bar-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.4s ease;
}

.status-foot {
  margin-top: 10px;
  font-size: 12px;
  color: #8a94a6;
}

.status-code {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  color: #a2abbd;
}

/* ลด spacing สำหรับมือถือ */
@media (max-width: 600px) {
  .dash-wrap {
    padding: 16px 16px 28px;
  }

  .dash-title {
    font-size: 22px;
  }

  .hero-grid,
  .status-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .hero-card {
    padding: 22px;
  }

  .hero-card .stat-value {
    font-size: 34px;
  }

  .stat-value {
    font-size: 30px;
  }

  .section-title {
    margin: 24px 0 12px;
  }
}
.v-simple-table th {
  font-weight: 600;
  font-size: 13px;
  color: #2c3e50;
}
.v-simple-table td {
  font-size: 13px;
  color: #34495e;
}

</style>
